module.exports = __webpack_public_path__ + "static/img/Testimonial2-blue.5288d5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Testimonial2-blue.png
// module id = Y0SP
// module chunks = 0